import e, { useState as f, useMemo as h, useEffect as k, useRef as v } from "react";
import n from "./index260.mjs";
import { ModalImageGallery as I } from "@amenitiz/design-system";
import C from "classnames";
import { useAtomValue as _ } from "jotai";
import { getConfigPropertyAtomCreator as w, ConfigProperty as b, ViewLayout as N } from "./index13.mjs";
const L = ({
  image: t,
  onImageClick: r
}) => /* @__PURE__ */ e.createElement(
  "img",
  {
    className: n["primary-image"],
    src: t.url,
    alt: I18n.t("booking_engine.accessibility.primary_image"),
    "data-testid": "primary-image",
    onClick: () => r(t.url)
  }
), R = ({ image: t, onImageClick: r, count: a }) => /* @__PURE__ */ e.createElement(
  "div",
  {
    className: n["image-with-overlay"],
    onClick: r,
    "data-testid": "image-with-overlay"
  },
  /* @__PURE__ */ e.createElement(
    "img",
    {
      src: t.url,
      alt: I18n.t("booking_engine.accessibility.additional_images")
    }
  ),
  /* @__PURE__ */ e.createElement("div", { className: n.overlay }, /* @__PURE__ */ e.createElement("span", null, "+", a))
), x = ({
  images: t,
  onImageClick: r
}) => /* @__PURE__ */ e.createElement("div", { className: n["image-rail"], "data-testid": "image-rail" }, t.map((a) => /* @__PURE__ */ e.createElement(
  "img",
  {
    key: a.url,
    src: a.url,
    alt: I18n.t("booking_engine.accessibility.gallery_image"),
    onClick: () => r(a.url),
    "data-testid": "image-rail-image"
  }
))), S = ({ images: t, count: r, onImageClick: a }) => /* @__PURE__ */ e.createElement("div", { className: n["image-rail"], "data-testid": "image-with-overlay-rail" }, t.map(
  (i, c) => c !== t.length - 1 ? /* @__PURE__ */ e.createElement(
    "img",
    {
      key: i.url,
      src: i.url,
      alt: I18n.t("booking_engine.accessibility.gallery_image"),
      onClick: () => a(i.url),
      "data-testid": "image-rail-image-no-overlay"
    }
  ) : /* @__PURE__ */ e.createElement(
    R,
    {
      key: i.url,
      image: i,
      count: r,
      onImageClick: () => a(i.url)
    }
  )
)), M = ({ images: t, onImageClick: r }) => /* @__PURE__ */ e.createElement("div", { className: n["image-gallery-two"], "data-testid": "image-gallery-two" }, t.map((a) => /* @__PURE__ */ e.createElement(
  "img",
  {
    key: a.url,
    src: a.url,
    alt: I18n.t("booking_engine.accessibility.gallery_image"),
    onClick: () => r(a.url)
  }
))), W = ({ images: t }) => {
  const [r, a] = f(!1), c = _(
    h(() => w(b.VIEW_LAYOUT), [])
  ) === N.FULL_SCREEN;
  k(() => {
    const l = window.matchMedia("(min-width: 1024px)");
    a(l.matches);
    const m = (o) => {
      a(o.matches);
    };
    return l.addEventListener("change", m), () => l.removeEventListener("change", m);
  }, []);
  const u = v(null), s = (l) => {
    var o;
    const m = t.findIndex((d) => d.url === l);
    (o = u.current) == null || o.open(m);
  };
  if (t.length === 0)
    return null;
  const y = t.map((l) => ({
    url: l.url,
    alt: l.url
  }));
  if (t.length === 2)
    return /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(M, { images: t, onImageClick: s }), /* @__PURE__ */ e.createElement(I, { items: y, ref: u }));
  const E = t[0], g = t.slice(1), p = () => {
    const l = r && c ? 5 : 3, m = l + 1;
    if (g.length > l) {
      const o = g.slice(0, l), d = t.length - m;
      return /* @__PURE__ */ e.createElement(
        S,
        {
          images: o,
          count: d,
          onImageClick: s
        }
      );
    }
    if (g.length > 1)
      return /* @__PURE__ */ e.createElement(x, { images: g, onImageClick: s });
  };
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: C(n["image-gallery"], {
        [n["image-gallery-fullscreen"]]: c
      }),
      "data-testid": "image-gallery"
    },
    /* @__PURE__ */ e.createElement(L, { image: E, onImageClick: s }),
    p(),
    /* @__PURE__ */ e.createElement(I, { items: y, ref: u })
  );
};
export {
  W as ImageGallery
};
